import React, { lazy, Suspense, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
const AddCategoryModal = lazy(() =>
  import("src/features/Modal").then((modal) => ({
    default: modal.AddCategoryModal,
  }))
);

export default function AddRowButton() {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <Button
        style={{ marginBottom: 15 }}
        icon={<PlusOutlined />}
        type="primary"
        onClick={() => setOpen(true)}
      >
        Добавить категорию
      </Button>
      {isOpen ? (
        <Suspense fallback={<div></div>}>
          <AddCategoryModal isOpen={isOpen} setOpen={setOpen} />
        </Suspense>
      ) : null}
    </>
  );
}
